<template>
  <v-container class="pa-0">
    <v-row
      no-gutters
      class="ma-4"
    >
      <v-col
        v-for="(category, index) in categories"
        :key="index"
        cols="6"
      >
        <category-cell
          class="ma-1"
          :category="category"
          @categoryDidSelected="$emit('categoryDidSelected', $event)"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import CategoryCell from '../cells/OptionsCategoryCell.vue'

  export default {
    name: 'OptionsCategoriesList',

    components: {
      CategoryCell,
    },

    props: {
      categories: Array,
    },
  }
</script>
